import * as THREE from 'three';
import BaseMesh from './base-mesh';
class Image extends BaseMesh {
    material;
    texture;
    constructor(data) {
        super(data);
        const { opacity = 1, visible = true } = this.props;
        const { url, width, height } = this.props.renderProps;
        this.visible = visible;
        this.material = new THREE.MeshBasicMaterial();
        this.geometry = new THREE.PlaneGeometry(width, height); // 二维矩形平面
        this.texture = null;
        this._createTexture(url).then((texture) => {
            this.material = new THREE.MeshBasicMaterial({
                map: texture,
                side: THREE.FrontSide,
                transparent: true,
                depthTest: false,
                opacity,
            });
            this.material.needsUpdate = true;
        });
    }
    update(data) {
        const { opacity = 1 } = data;
        const { url: newUrl, width: newWdith, height: newHeight } = data.renderProps;
        const { url, width, height } = this.props.renderProps;
        if (newUrl !== url) {
            this._createTexture(url).then((texture) => {
                this.material.map = texture;
            });
        }
        if (newWdith !== width || newHeight !== height) {
            this.geometry = new THREE.PlaneGeometry(newWdith, newHeight); // 二维矩形平面
        }
        this.material.opacity = opacity;
        super.update(data);
    }
    _createTexture(url) {
        return new Promise((resolve) => {
            new THREE.TextureLoader().load(url, (texture) => {
                this.texture?.dispose();
                // 去除黑边
                texture.minFilter = THREE.NearestFilter;
                texture.magFilter = THREE.NearestFilter;
                texture.needsUpdate = true;
                this.texture = texture;
                resolve(texture);
            });
        });
    }
    dispose() {
        super.dispose();
        this.texture?.dispose();
    }
    onClick() {
        super.onClick();
    }
    onMouseenter() {
        document.body.style.cursor = 'pointer';
        const { activeUrl } = this.props.renderProps;
        this._createTexture(activeUrl).then((texture) => {
            this.material.map = texture;
        });
    }
    onMouseleave() {
        document.body.style.cursor = '';
        const { url } = this.props.renderProps;
        this._createTexture(url).then((texture) => {
            this.material.map = texture;
        });
    }
}
export default Image;
